import React, { useState, useEffect } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { useParams, useNavigate } from "react-router";
import axios from "axios";
import "../css/ReporteIncidencias.css";

const ReporteIncidencias = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const URL_API = process.env.REACT_APP_URL_API || 'http://localhost:5000';
  const [formattedData, setFormattedData] = useState([]);
  const [aula, setAula] = useState(id || "");

  useEffect(() => {
    if (id) {
      axios.get(URL_API + `incidencias-aula/${id}`).then((res) => {
        setFormattedData(
          res.data.map((item) => {
            const categorias = item.incidencias.reduce(
              (acc, incidencia) => {
                acc[incidencia.categoria] = incidencia.total;
                return acc;
              },
              { Apropiado: 0, Inapropiado: 0 }
            );

            return {
              dia: item.dia,
              ...categorias,
            };
          })
        );
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const aulas = [
    { value: "1", label: "Aula 11" },
    { value: "2", label: "Aula 12" },
    { value: "3", label: "Aula 13" },
    { value: "4", label: "Aula 14" },
    { value: "5", label: "Aula 15" },
    { value: "6", label: "Aula 16" },
    { value: "7", label: "Aula 17" },
    { value: "8", label: "Aula SUMPA" },
    { value: "9", label: "Aula SAVPA" },
  ];

  return (
    <div className="container">
      <div className="header">
        <div className="title-section">
          <h1 className="title">Incidencias por Día en el Aula</h1>
        </div>
        <div className="filter-section">
          <div className="input-group">
            <label htmlFor="aula-select">Aula a consultar</label>
            <select
              id="aula-select"
              className="filter-input"
              value={aula}
              onChange={(e) => setAula(e.target.value)}
            >
              <option value="">Seleccione un aula</option>
              {aulas.map((aulaOption) => (
                <option key={aulaOption.value} value={aulaOption.value}>
                  {aulaOption.label}
                </option>
              ))}
            </select>
          </div>
          <button onClick={() => navigate(`/incidencias/${aula}`)} className="consult-btn">
            Consultar
          </button>
        </div>
      </div>

      {formattedData.length === 0 ? (
        <p className="no-data">No hay registros</p>
      ) : (
        <ResponsiveContainer width="80%" height={300} className="chart-container">
          <BarChart
            data={formattedData}
            margin={{ top: 20, right: 30, left: 30, bottom: 50 }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis
              dataKey="dia"
              tick={{ textAnchor: "middle", fontSize: 14 }}
              interval={0}
            />
            <YAxis />
            <Tooltip />
            <Legend />
            <Bar dataKey="Apropiado" stackId="a" fill="#00BF63" barSize={50} />
            <Bar dataKey="Inapropiado" stackId="a" fill="#FF5733" barSize={50} />
          </BarChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

export default ReporteIncidencias;